import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY } from '../data/siteData';

const FOOTER_LINKS = [
    { to: '/about', label: 'О компании' },
    { to: '/contacts', label: 'Контакты' },
    { to: '/requisites', label: 'Реквизиты' },
    { to: '/vacancies', label: 'Вакансии' },
    { to: '/conditions', label: 'Условия работы' },
    { to: '/faq', label: 'FAQ' },
    { to: '/privacy', label: 'Политика конфиденциальности' },
    { to: '/terms', label: 'Пользовательское соглашение' }
];

const Footer = () => (
    <footer className="site-footer">
        <div className="container">
            <p className="site-footer-legal">
                Информационные услуги. ИНН {COMPANY.inn} ОГРНИП {COMPANY.ogrn} {COMPANY.address}
            </p>
            <p className="site-footer-contact">
                <a href={`mailto:${COMPANY.email}`} className="site-footer-email">
                    {COMPANY.email}
                </a>
            </p>
            <nav className="site-footer-nav" aria-label="Дополнительная навигация">
                {FOOTER_LINKS.map(({ to, label }) => (
                    <Link key={to} to={to} className="site-footer-nav-link">
                        {label}
                    </Link>
                ))}
            </nav>
        </div>
    </footer>
);

export default Footer;
